import router from 'next/router';
import { PUBLIC_HOST } from '@config/index';
import { IGeoData, TLocale } from '@typescript/index';
import { fetcher } from '@utils/fetcher';
import getPublicEnv from '@utils/getPublicEnv';

class NextGeoDataApi {
  public endpoints = {
    getUserGeolocation: () => `user-geolocation`,
  };

  private static geoDataFetcher = (url: string, options: Record<string, string>, locale: TLocale) => {
    const headers = {
      'content-type': 'application/json',
    };

    return fetcher(`${PUBLIC_HOST}/api/${locale}/${url}`, {
      ...options,
      headers,
    });
  };

  public async getGeoData(): Promise<{
    userGeolocation: IGeoData;
    locale: TLocale;
  } | null> {
    const { locale } = router;
    const newLocale = (locale as TLocale) || (getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE') as TLocale);
    const { json, status } = await NextGeoDataApi.geoDataFetcher(
      this.endpoints.getUserGeolocation(),
      {
        method: 'GET',
      },
      locale as TLocale,
    );
    return status === 200 && json?.userGeolocation && locale
      ? { userGeolocation: json?.userGeolocation, locale: newLocale }
      : null;
  }
}

export default new NextGeoDataApi();
